<template>
    <div>
      <!-- 面包屑导航 -->
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>商品管理</el-breadcrumb-item>
        <el-breadcrumb-item>首页推荐列表</el-breadcrumb-item>
      </el-breadcrumb>
      <br />
      <el-form :inline="true" :model="formInline">
        <el-form-item label="商品名称">
          <el-input
            size="small"
            clearable
            v-model="formInline.productName"
            placeholder="请输入商品名称"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
        </el-form-item>
      </el-form>
      <el-table size="small" :data="listData"
      :header-cell-style="{'text-align':'center'}"
      highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;">
      <el-table-column type="index" align='center'>
        </el-table-column>
      <el-table-column prop="productName" label="商品名称" show-overflow-tooltip align='center'>
        </el-table-column>
        <el-table-column sortable prop="productAmount" label="商品价格" show-overflow-tooltip align='center'>
        </el-table-column>
        <el-table-column align="center" label="操作" width="250">
          <template slot-scope="scope">
            <el-button size="mini" type="danger" @click="deleteProduct(scope.$index, scope.row)">从推荐表删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页组件 -->
      <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
    </div>
  </template>

  <script>
  import { recommendList,delRecommend } from '../../api/basisMG'
  import Pagination from '../../components/Pagination'
  import { getDictByTypeId} from '@/api/system'
  import LocalQuillEditor from '@/components/editor'
  export default {
    data() {
      return {
        loading: false, //是显示加载
        editFormVisible: false, //控制编辑页面显示与隐藏
        title: '预览',
        sourceOptions:[],
        flagOptions:[],
        uploadheaders:{
          Authorization: localStorage.getItem('logintoken')
        },
        // editForm: {
        //   name:'',
        // },
        formInline: {
          page: 1,
          limit: 10,
        },
        // 删除部门
        seletedata: {
          ids: '',
        },
        userparm: [], //搜索权限
        listData: [], //用户数据
        // 分页参数
        pageparm: {
          currentPage: 1,
          pageSize: 10,
          total: 10
        }
      }
    },
    // 注册组件
    components: {
      Pagination,LocalQuillEditor
    },
    /**
     * 数据发生改变
     */

    /**
     * 创建完毕
     */
    created() {
      this.getdata(this.formInline)
      this.getDictByTypeId()
    },

    /**
     * 里面的方法只有被调用才会执行
     */
    methods: {
      // 获取药品来源字典
      getDictByTypeId(){
        getDictByTypeId(2).then(res=>{
          this.sourceOptions = res.body
        })
        getDictByTypeId(8).then(res=>{
          this.flagOptions = res.body
        })
      },
      // 获取列表
      getdata(parameter) {
        this.loading = true
        /***
         * 调用接口
         */
         recommendList(parameter)
          .then(res => {
            this.loading = false
            if (res.rsp_code !== 200) {
              this.$message({
                type: 'info',
                message: res.rsp_msg
              })
            } else {
              this.listData = res.body.records
              // 分页赋值
              this.pageparm.currentPage = this.formInline.page
              this.pageparm.pageSize = this.formInline.limit
              this.pageparm.total = res.body.total
            }
          })
          .catch(err => {callFather
            this.loading = false
            this.$message.error('加载失败，请稍后再试！')
          })
      },
      // 分页插件事件
      callFather(parm) {
        this.formInline.page = parm.currentPage
        this.formInline.limit = parm.pageSize
        this.getdata(this.formInline)
      },
      // 搜索事件
      search() {
        this.formInline.page=1
        this.getdata(this.formInline)
      },
      // 删除
      deleteProduct(index, row) {
        this.$confirm('确定要删除吗?', '信息', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
          .then(() => {
            delRecommend({id:row.id})
              .then(res => {
                if (res.rsp_code ==200) {
                  this.$message({
                    type: 'success',
                    message: '删除成功!'
                  })
                  this.getdata(this.formInline)
                } else {
                  this.$message({
                    type: 'info',
                    message: res.rsp_msg
                  })
                }
              })
              .catch(err => {
                this.loading = false
                this.$message.error('删除失败，请稍后再试！')
              })
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: '已取消删除'
            })
          })
      },
    }
  }
  </script>
  <style>
  .avatar-uploader .el-upload {
      border: 1px dashed #d9d9d9;
      border-radius: 6px;
      cursor: pointer;
      position: relative;
      overflow: hidden;
    }
    .avatar-uploader .el-upload:hover {
      border-color: #409EFF;
    }
    .avatar-uploader-icon {
      font-size: 28px;
      color: #8c939d;
      width: 178px;
      height: 178px;
      line-height: 178px;
      text-align: center;
    }
    .avatar {
      width: 178px;
      height: 178px;
      display: block;
    }
  </style>
  <style scoped>
  .user-search {
    margin-top: 20px;
  }
  .userRole {
    width: 100%;
  }
  </style>







// WEBPACK FOOTER //
// src/views/product/recommendList.vue